//TODO: update icons if will be necessary
import i18n from '@/i18n.js'
import { getActiveLayoutColors } from '@/composables/globalData/useLayouts'

const { inCall, onHold } = getActiveLayoutColors()

export const COUNTER_TYPES = {
    COUNTER: 'counter',
    WAIT_TIME: 'waitTime',
} as const

type CounterKind = typeof COUNTER_TYPES[keyof typeof COUNTER_TYPES]

type TypeConfig = {
    id: number
    icon: string
    type: CounterKind;
    color: string
    text: string
}

export const CALLERS_TYPE_CONFIG = {
    id: 0,
    icon: 'PhoneCall',
    type: COUNTER_TYPES.COUNTER,
    color: inCall,
    text: 'queue.counter.callers'
} as const
export const MAXIMUM_WAITING_TYPE_CONFIG = {
    id: 1,
    icon: 'CalendarClock',
    type: COUNTER_TYPES.WAIT_TIME,
    color: onHold,
    text: 'queue.maximum.waiting.caller'
} as const
export const CALLERS_VIRTUAL_TYPE_CONFIG = {
    id: 2,
    icon: 'PhoneCall',
    type: COUNTER_TYPES.COUNTER,
    color: inCall,
    text: 'queue.amount.callers_virtual.waiting'
} as const
export const CALLERS_NOT_VIRTUAL_TYPE_CONFIG = {
    id: 3,
    icon: 'PhoneCall',
    type: COUNTER_TYPES.COUNTER,
    color: inCall,
    text: 'queue.amount.callers_not_virtual.waiting'
} as const
export const MAXIMUM_VIRTUAL_WAITING_TYPE_CONFIG = {
    id: 4,
    icon: 'CalendarClock',
    type: COUNTER_TYPES.WAIT_TIME,
    color: onHold,
    text: 'queue.maximum.waiting.caller.virtual'
} as const
export const MAXIMUM_NOT_VIRTUAL_WAITING_TYPE_CONFIG = {
    id: 5,
    icon: 'CalendarClock',
    type: COUNTER_TYPES.WAIT_TIME,
    color: onHold,
    text: 'queue.maximum.waiting.caller.not_virtual'
} as const

export const typesList = [
    CALLERS_TYPE_CONFIG,
    MAXIMUM_WAITING_TYPE_CONFIG,
    CALLERS_VIRTUAL_TYPE_CONFIG,
    CALLERS_NOT_VIRTUAL_TYPE_CONFIG,
    MAXIMUM_NOT_VIRTUAL_WAITING_TYPE_CONFIG,
    MAXIMUM_VIRTUAL_WAITING_TYPE_CONFIG
] as const satisfies readonly TypeConfig[]

export type TypeId = typeof typesList[number]['id']
export type CounterTypeId = Extract<
    typeof typesList[number],
    { type: typeof COUNTER_TYPES.COUNTER }
>['id']

const COUNTER_TYPE_ID_SET: ReadonlySet<number> = new Set<number>(
    typesList.filter(t => t.type === COUNTER_TYPES.COUNTER).map(t => t.id)
)

export const types = Object.fromEntries(
    typesList.map(el => {
        return [
            el.id,
            el
        ]
    })
)

export function isCounter (type: number): type is CounterTypeId {
    return COUNTER_TYPE_ID_SET.has(type)
}

export const typeNamesMapped = () => {
    return typesList.map((item) => {
        return {
            value: item.id,
            label: i18n.t(item.text)
        }
    })
}

export const AVERAGE_DURATION_ALL_CALLS = 'Average duration of all calls'
export const AVERAGE_DURATION_INCOMING_CALLS = 'Average duration of incoming calls'
export const AVERAGE_DURATION_OUTGOING_CALLS = 'Average duration of outgoing calls'

export const availableCounters = [
    {
        label: 'widget.statistics.averageDurationOfAllCalls',
        value: AVERAGE_DURATION_ALL_CALLS,
    },
    {
        label: 'widget.statistics.averageDurationOfIncomingCalls',
        value: AVERAGE_DURATION_INCOMING_CALLS,
    },
    {
        label: 'widget.statistics.averageDurationOfOutgoingCalls',
        value: AVERAGE_DURATION_OUTGOING_CALLS,
    },
]

export const AVERAGE_CALLS_DURATION_ICONS = {
    [AVERAGE_DURATION_ALL_CALLS]: 'PhoneCall',
    [AVERAGE_DURATION_INCOMING_CALLS]: 'PhoneIncoming',
    [AVERAGE_DURATION_OUTGOING_CALLS]: 'PhoneOutgoing'
}
